import { useLocalStorage } from "usehooks-ts";

export const useRedirectAfterLogin = () => {
  return useLocalStorage<string | undefined>("redirect_after_login", undefined);
};
